/**
 * frontend/src/stores/voileExportStore.ts
 * `#17` RAPPORT PPT — **L'AVANCEMENT DE L'EXPORT, HORS DE TOUTE PAGE.**
 *
 * ⚠⚠ `#656` — POURQUOI UN STORE, ET PAS UN `useState` DANS LE MODULE.
 *
 *   Le voile vivait dans `BoutonRapportPpt`, lui-même rendu par
 *   `MxRmFlowSection` — donc **par la page Marché**. *Un portail ne change rien
 *   à cela : il déplace le nœud dans le DOM, mais **il suit le cycle de vie de
 *   son composant hôte**. Quand la séquence quitte `/marche`, la page se
 *   démonte et le voile avec elle.*
 *
 * ⚠⚠ **ET C'EST UNE AFFIRMATION QUE J'AVAIS GRAVÉE À TORT AU `#643`** : « le
 *   voile persiste à travers la navigation (portail sur `document.body`) ».
 *   *C'était faux, et ça ne se voyait pas tant que Flash Info fermait la
 *   marche : le voile disparaissait à la toute fin, quand plus personne ne le
 *   regardait. Depuis que `F11` navigue au PREMIER geste (`#652`), il
 *   s'évanouit presque aussitôt.*
 *
 * ⚠ L'ÉTAT EST DONC PORTÉ **AU-DESSUS DU ROUTEUR** : la séquence écrit ici, et
 *   un seul `VoileExport`, monté une fois pour toute l'application, le lit.
 */

import { create } from 'zustand';
import type { AvancementSequence } from '@/modules/marche/hooks/useSequencePpt';

interface VoileExportStore {
  /** `null` = aucun export en cours. */
  avancement: AvancementSequence | null;
  poser: (a: AvancementSequence | null) => void;
}

export const useVoileExportStore = create<VoileExportStore>((set) => ({
  avancement: null,
  poser: (a) => set({ avancement: a }),
}));

/** ⚠ Lu par le voile — re-rend à chaque étape, ce qui est exactement le but. */
export const useAvancementExport = (): AvancementSequence | null =>
  useVoileExportStore((s) => s.avancement);
